import { Injectable } from '@angular/core';
import { StorageService } from './storage.service';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { SSOValidateInterface } from '../interfaces/catalogos.interface';



/**
 * Genera la sesion en el back y se obtienen  los catalogos necesarios para los flujos
 */
@Injectable()
export class CatalogosService {

  /**
   * Url del servicio a consultar
   */
  private url;

  /**
   * Inicializa la url  a consultar
   * @param localStorage
   * @param http
   */
  constructor(private  localStorage : StorageService,
              private http: HttpClient) {
                this.url = localStorage.get("HOST") + "/SSO/validate";
  }

  /**
   *
   * @param data Obtiene los catalogos
   */
  getCatalogos(data: string): Observable<SSOValidateInterface>{
      /**
       * Descomentar para pruebas
       */
      // return this.http.get<SSOValidateInterface>('../../assets/json/catalogos.json');
      /**
       *Descomentar para ambientes
       */
      return this.http.post<SSOValidateInterface>(this.url,data);
  }
}
